export default "__VITE_ASSET__BHXl6Gb0__"